import { render, staticRenderFns } from "./action-menu.vue?vue&type=template&id=1776bd0e&"
import script from "./action-menu.vue?vue&type=script&lang=js&"
export * from "./action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports